import 'bootstrap-icons/font/bootstrap-icons.css';
import Rails from '@rails/ujs';
import 'core-js/stable';
import './jquery-setup';
import 'jquery-modal';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';
import AlertContentTransition from './alertContentTransition';
import { Favorite } from './components/Favorite';
import Header from './components/Header';
import PreventErroneousSubmit from './prevent_erroneous_submit';

Rails.start();

if (!window?.Coorum) {
  window.Coorum = {};
}
window.flatpickr = flatpickr;
window.Coorum.PreventErroneousSubmit = PreventErroneousSubmit;
window.Coorum.AlertContentTransition = AlertContentTransition;
window.Coorum.Favorite = Favorite;

document.addEventListener('DOMContentLoaded', () => {
  new Header();

  // NOTE: jquery-modalを利用している箇所で必要らしい
  // `.js-menu_contents` / `.js-menu_open` は現在どのDOMにも存在せず、この除外条件は
  // 常にfalseになっていた（＝実質どのクリックでも body のインラインスタイルを
  // unset していた）。ヘッダーの検索/ドロワー/通知はいずれもクリックで開閉し、
  // 開閉中は .js-Header 配下の要素（ドロワーパネルやオーバーレイ含む）しかクリックできない
  // （オーバーレイが画面全体を覆うため）。ここで unset してしまうと、CSS側のスクロール
  // ロック（_base.scss、documentElement の `-xxx-locked` クラスで発火）をインライン
  // スタイルの優先度で上書きしてしまい、ロック中でも背景がスクロールできてしまう
  // （例: ハンバーガーメニュー展開中の背景スクロール）。開閉トリガーとなる
  // .js-Header 配下のクリックは reset 対象から除外する。
  if ($('.js-Header').length > 0) {
    $(document).on('click', function (e) {
      if (!$(e.target).closest('.js-Header, .js-menu_contents, .js-menu_open').length) {
        $('body').attr({ style: 'overflow: unset;' });
      }
    });
  }

  $('.modal').on($.modal.BEFORE_BLOCK, (e, modal) => {
    const blockerClassName = modal?.$elm[0]?.dataset?.modalBlockerClassName;
    blockerClassName &&
      (modal.options.blockerClass = `jquery-modal ${blockerClassName}`);
  });

  updateHeightPost();
});

window.addEventListener('load', () => {
  new Coorum.PreventErroneousSubmit();
});

$(function () {
  $('.header--sp__menu').outerHeight(
    $(window).outerHeight() - $('.header--sp__user').outerHeight()
  );
});

$(function () {
  $(document).on('click', '.js-download_file', function () {
    downloadFile($(this).data('fileUrl'), $(this).data('fileName'));
  });
});

$(function () {
  // タイムライン/チップのタブ切替リンク（communities/show.html.erb, communities/_chips.html.erb）。
  // クリック時にローディング表示 + history.pushState でURLを更新する。CSPでonclick属性が
  // ブロックされるため、イベントデリゲーションに置き換えた。pushState先はリンク自身の
  // pathname/searchを使う（既存のonclickもハッシュ（#discussion等）を含めずに書かれていたため、
  // その挙動を維持する）
  // rails-ujs は remote: true のリンクを document のリスナーで処理し stopImmediatePropagation するため、
  // document に委譲すると届かない。document より先にイベントを受け取る body に委譲する
  document.body.addEventListener('click', (e) => {
    const link = e.target.closest('.js-loader-nav');
    if (!link) return;

    document.querySelectorAll('.loader-bg, .loader').forEach((el) => {
      el.style.display = 'block';
    });
    history.pushState({}, '', link.pathname + link.search);
  });
});

$(function () {
  // 隠した<input type="file">を開くボタン（プロフィール編集・投稿フォームの画像アップロード）。
  // CSPでonclick属性がブロックされるため、イベントデリゲーションに置き換えた。<label for="...">への
  // 置き換えも検討したが、labelはキーボードフォーカス・Enter/Spaceでの起動ができず、対象inputも
  // display:noneのためキーボード操作が失われる（Copilotのレビュー指摘）。<button>のまま維持し、
  // キーボード操作（Tabでフォーカス→Enter/Spaceでクリック）を保持する
  document.body.addEventListener('click', (e) => {
    const trigger = e.target.closest('.js-file-select-trigger');
    if (!trigger) return;

    document.getElementById(trigger.dataset.targetId)?.click();
  });
});

function downloadFile(url, filename) {
  'use strict';

  // XMLHttpRequestオブジェクトを作成する
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob'; // Blobオブジェクトとしてダウンロードする
  xhr.onload = function (oEvent) {
    // ダウンロード完了後の処理を定義する
    var blob = xhr.response;
    if (window.navigator.msSaveBlob) {
      // IEとEdge
      window.navigator.msSaveBlob(blob, filename);
    } else {
      // それ以外のブラウザ
      // Blobオブジェクトを指すURLオブジェクトを作る
      var objectURL = window.URL.createObjectURL(blob);
      // リンク（<a>要素）を生成し、JavaScriptからクリックする
      var link = document.createElement('a');
      document.body.appendChild(link);
      link.href = objectURL;
      link.download = filename;
      link.click();
      document.body.removeChild(link);
    }
  };
  // XMLHttpRequestオブジェクトの通信を開始する
  xhr.send();
}

function updateHeightPost() {
  // モバイルアプリより開いている時のみ有効になります
  if (typeof updateHeight !== 'undefined' && updateHeight?.postMessage) {
    updateHeight.postMessage(document.body.scrollHeight);
  }
}

window.updateTokenAtResume = (token) => {
  $.ajax({
    type: 'POST',
    url: '/devices',
    dataType: 'json',
    data: {
      device: { token: token },
    },
  });
};

window.getNewPosts = () => {
  $.ajax({
    type: 'GET',
    url: '/community/new_posts',
    dataType: 'json',
  }).done((response) => {
    if (typeof getNewPostsChannel === 'undefined') return;
    getNewPostsChannel.postMessage(JSON.stringify(response));
  });
};

window.getNewComments = () => {
  $.ajax({
    type: 'GET',
    url: '/community/new_comments',
    dataType: 'json',
  }).done((response) => {
    if (typeof getNewCommentsChannel === 'undefined') return;
    getNewCommentsChannel.postMessage(JSON.stringify(response));
  });
};
